import moment from "moment";

export default (api) => {
  api.debug = {
    public: {
    },
    admin: {
      filePermissionWrite: (driver) => api.request({
        url: `/api/admin/debug/file-permission/write`,
        type: 'post',
        params: {
          driver,
        },
      }),
      truncateYearlyReport: (year) => api.request({
        url: `/api/admin/debug/report/yearly/${year}`,
        type: 'delete',
      }),
      syncDailyReport: (reportType, date) => api.request({
        url: `/api/admin/debug/report/daily/${reportType}`,
        type: 'post',
        params: { date },
      }),
      syncWeeklyReport: (reportType, start) => api.request({
        url: `/api/admin/debug/report/weekly/${reportType}`,
        type: 'post',
        params: { start },
      }),
      syncYearlyReport: (reportType, year) => api.request({
        url: `/api/admin/debug/report/yearly/${reportType}`,
        type: 'post',
        params: { year },
      }),
    },
  }
}